declare var Alkami: any;

Alkami.Dom.onDocumentReady(() => {

    if (Alkami.BrowserSupport) {
        const support = Alkami.BrowserSupport.getSupport();

        if (support.isMobile) {
            if (support.isMobileUnsupported) {
                Alkami.BrowserSupport.displayMobileUnsupportedMessage();
                return;
            }
        } else {
            if (support.showPopup) {
                Alkami.BrowserSupport.displayUnsupportedMessage();
                return;
            }
        }

        // Check whether or not cookies are enabled
        if (!support.hasCookies) {
            Alkami.BrowserSupport.displayCookiesDisabledMessage();
            return;
        }
    }
});